var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrandXiaomi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1804_8228)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8281 0.253418H0.0249062V19.9807H19.8281V0.253418ZM6.50195 6.92154H5.19111C5.13546 6.92154 5.08938 6.96772 5.08938 7.02462V13.2109C5.08938 13.2673 5.13546 13.3135 5.19111 13.3135H6.50195C6.55808 13.3135 6.60352 13.2673 6.60352 13.2109V7.02462C6.60352 6.96772 6.55808 6.92154 6.50195 6.92154ZM9.66729 6.92154H14.6605C14.7166 6.92154 14.7617 6.96772 14.7617 7.02462V13.2109C14.7617 13.2673 14.7166 13.3135 14.6605 13.3135H13.3493C13.2935 13.3135 13.2473 13.2673 13.2473 13.2109V8.35559C13.2473 8.29951 13.2021 8.253 13.146 8.253H10.3217C9.52746 8.253 9.30199 8.8822 9.30199 9.28809V13.2109C9.30199 13.2673 9.25639 13.3135 9.20026 13.3135H7.8899C7.83409 13.3135 7.78834 13.2673 7.78834 13.2109V8.82233C7.78834 8.46032 7.83043 7.93981 8.28199 7.48164C8.75444 7.00335 9.18544 6.92154 9.66729 6.92154ZM11.9622 9.38523H10.5857C10.5301 9.38523 10.4845 9.43141 10.4845 9.48798V13.2111C10.4845 13.2673 10.5301 13.3135 10.5857 13.3135H11.9622C12.0184 13.3135 12.0645 13.2673 12.0645 13.2111V9.48798C12.0645 9.43141 12.0184 9.38523 11.9622 9.38523Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1804_8228"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.7714,
    height: 19.7714,
    rx: 2.25959,
    transform: "matrix(-1 0 0 1 19.7949 0.25293)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandXiaomi);
export default __webpack_public_path__ + "static/media/brand-xiaomi.a1c503de7f2f947b70ea37c503a125f0.svg";
export { ForwardRef as ReactComponent };